<template>
    <div>
        fff
    </div>
</template>
<style lang="scss" scoped>

</style>
<script>
export default {
    data(){
        return{}
    }
}
</script>